import { useQuery, useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Alert,
  Grid,
  Button,
} from '@mui/material';
import {
  ArrowBack as BackIcon,
  PlayArrow as StartIcon,
} from '@mui/icons-material';
import { processApi } from '../api/services';

export function NewProcessPage() {
  const navigate = useNavigate();

  const { data: definitions, isLoading, error } = useQuery({
    queryKey: ['process-definitions'],
    queryFn: processApi.getDefinitions,
  });

  const startMutation = useMutation({
    mutationFn: (key: string) => processApi.startProcess(key, {}),
    onSuccess: (data) => {
      navigate(`/processes/${data.id}`);
    },
  });

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return <Alert severity="error">Fehler beim Laden der Prozessdefinitionen</Alert>;
  }

  return (
    <Box>
      <Button
        startIcon={<BackIcon />}
        onClick={() => navigate('/processes')}
        sx={{ mb: 2 }}
      >
        Zurueck
      </Button>

      <Typography variant="h4" gutterBottom>
        Neuen Antrag starten
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Waehlen Sie den gewuenschten Antragstyp aus
      </Typography>

      <Grid container spacing={3}>
        {definitions?.map((definition) => (
          <Grid item xs={12} md={6} key={definition.id}>
            <Card
              sx={{
                cursor: 'pointer',
                transition: 'transform 0.2s, box-shadow 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 4,
                },
              }}
              onClick={() => startMutation.mutate(definition.key)}
            >
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6" sx={{ flexGrow: 1 }}>
                    {definition.name || definition.key}
                  </Typography>
                  <StartIcon color="primary" />
                </Box>
                {definition.description && (
                  <Typography variant="body2" color="text.secondary">
                    {definition.description}
                  </Typography>
                )}
                <Box sx={{ mt: 2 }}>
                  <Button
                    variant="contained"
                    disabled={startMutation.isPending}
                    startIcon={
                      startMutation.isPending ? (
                        <CircularProgress size={16} />
                      ) : (
                        <StartIcon />
                      )
                    }
                  >
                    Antrag starten
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {(!definitions || definitions.length === 0) && (
        <Alert severity="info">
          Keine Antragstypen verfuegbar
        </Alert>
      )}
    </Box>
  );
}
